import React from 'react';
import '../App.css';

function About() {
  return (
    <div className="page-shell">
      <h3>关于我们</h3>
      <p>&nbsp;</p>
      <p className="page-lead">科技行业的创新显示解决方案提供商。</p>
      <p>欢迎来到 Wind，我们公司是一家科技行业的领先企业，成立于 2025 年。自成立以来，我们始终坚持以客户为中心，注重质量和服务，致力于为客户提供最优质的产品和解决方案。</p>
    </div>
  );
}
export default About;
